export const apiBase = process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === 'development' ? '/tc-server' : 'https://peiqisport.club')
